import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../utils/request';
import { METHOD_POST } from '../../constants/api';
import getOrderedPartTypeList from './getOrderedPartTypeList';

export const clearPostOrderedPartTypeData = createAction('articles/clearPostOrderedPartTypeData');

const postOrderedPartType = createAsyncThunk('general/postOrderedPartType',
  async (formData = {}, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await authSet(METHOD_POST, '/general/list/orderedTypes', formData);
      dispatch(getOrderedPartTypeList());
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default postOrderedPartType;
